import React from 'react'
import { Link } from 'react-router-dom'
import registerVector from '../../../Assets/registerVector.png'
import googleIcon from '../../../Assets/iconGoogle.svg'
import mail from '../../../Assets/mailGrey.svg'
import key from '../../../Assets/key.svg'
import eye from '../../../Assets/eye.svg'

const SignIn = () => {
  return (
    <div className='registerContainer'>
      <div className="registerFormContainer">
        
        <div className="registerHeader">
          <h1>Welcome back!</h1>
          <p>Welcome back, Please enter your details</p>
        </div>

        <div className="registerForm">
        
          <button><img src={googleIcon} alt="" />Log in with google</button>
        
          <div className="or">
            <hr />
            <p>Or</p>
            <hr />
          </div>
        
          <form className='register' action="" id='signInForm'>
        
            <div className="registerInputContainer">
              <img src={mail} alt="" className='lIcon' />
              <input type="text" placeholder='Enter Your Email' />
            </div>
        
            <div className="registerInputContainer">
              <img src={key} alt="" className='lIcon' />
              <input type="password" placeholder='Enter Password' />
              <img src={eye} alt="" className='key' />
            </div>

            <div className="registerInputContainer"  id='forgotPasswordContainer'>
              <Link to='' className='forgetPassword'  id='forgotPassword'>Forget Password</Link>
            </div>

            {/* <div className="registerInputContainer">
              <img src={key} alt="" className='lIcon' />
              <input type="password" placeholder='Confirm Password' />
              <img src={eye} alt="" className='key' />
            </div> */}

            <button id='signinBtn'>Sign in</button>

          </form>

          <p className="switch">Don't have account? <Link to='/register'> Register now!</Link></p>

        </div>

      </div>

      <div className="registerImg">
        <div className="imgText">
          <h4>Nidaan</h4>
          <p>One and only Advance AI healthcare Solution</p>
        </div>
        <img src={registerVector} alt="" />
      </div>

    </div>
  )
}

export default SignIn